export default {
  methods: {
    coinsToString(coins) {
      return new Intl.NumberFormat().format(coins)
    },
  }
}
